"use strict";
import { Record } from "immutable";
const isNeed = (object) => object && (object.__type__ === "need" || object.__type__ === "needCollection");
const NeedCollection = Record({
  "__type__": "needCollection",
  needs: null
});
const map = (ids, mappingFunction, type = "list") => {
  if (isNeed(ids)) {
    return ids;
  }
  const values = ids.map(mappingFunction);
  const needs = values.filter(isNeed);
  if (needs.isEmpty()) {
    return type === "set" ? values.toSet() : values;
  }
  return NeedCollection({
    needs
  });
};
const flatMap = (ids, mappingFunction, type = "list") => {
  if (isNeed(ids)) {
    return ids;
  }
  const flatIds = type === "set" ? ids.flatten().toSet() : ids.flatten();
  return map(flatIds, mappingFunction, type);
};
const zip = (collection1, collection2) => {
  if (isNeed(collection1)) {
    return collection1;
  } else if (isNeed(collection2)) {
    return collection2;
  }
  return collection1.zip(collection2);
};
export default {
  map,
  flatMap,
  zip
};
